export default __webpack_public_path__ + "static/media/metric-iec-single.89a8a8ab.png";